import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=393186e7&"
import script from "./Province.vue?vue&type=script&lang=ts&"
export * from "./Province.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports